function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.3,20.2C25,18.4 23.8,17.2 22.2,17.2C20.2,17.2 18.5,18.8 18.5,20.9C18.5,21.1 18.5,21.3 18.6,21.5C15.4,21.9 13,23.8 12.8,26.2C12.8,26.3 12.8,26.4 12.8,26.5C11.6,23.8 10.2,20.3 10.2,18.3C10.2,13.3 14.1,9.2 19.2,9.1C23.7,9.2 27.3,12.4 28,16.7C28,16.8 28,16.9 28,16.9C28.1,17.2 28.4,17.4 28.7,17.4C29.1,17.4 29.4,17.1 29.4,16.8L29.4,16.7L29.4,16.6C28.6,11.7 24.4,8 19.2,7.8L19.1,7.8C13.4,7.7 8.8,12.4 8.8,18.2C8.8,22 13.3,30.7 13.4,31C13.5,31.2 13.8,31.4 14,31.4L19.1,31.4C19.5,31.4 19.8,31.1 19.8,30.7C19.8,30.3 19.5,30 19.1,30L14.4,30C14.3,29.8 14.1,29.5 14,29.1L14,26.8C14,26.6 14,26.5 14,26.3C14.1,24.4 16.4,22.9 19.4,22.8C19.6,22.8 19.8,22.7 19.9,22.5C20,22.3 20,22.1 19.9,21.9C19.8,21.6 19.7,21.3 19.7,21C19.7,19.7 20.8,18.6 22.1,18.6C23.5,18.6 23.9,19.9 24,21C24,21.2 24.1,21.3 24.2,21.5C24.3,21.6 24.5,21.7 24.7,21.7L25.1,21.7C27.4,21.7 29.1,23.7 29.1,24.9C29.1,25.8 28,26.3 25.8,26.4C25.5,26.4 25.3,26.6 25.2,26.9C25.1,27.2 25,27.6 25,28C24.9,28.3 24.8,28.9 24.8,29C24.6,29.3 24.7,29.7 25,29.9C25.1,30 25.2,30 25.4,30C25.6,30 25.8,29.9 25.9,29.7C26.1,29.4 26.2,29 26.3,28.2C26.3,28 26.4,27.9 26.4,27.7C29.1,27.5 30.4,26.6 30.4,24.9C30.5,22.7 28.2,20.2 25.3,20.2Z",
    style: {
      fill: "rgb(41,171,226)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,33.4L14.3,33.4C13.9,33.4 13.6,33.7 13.6,34.1C13.6,34.5 13.9,34.8 14.3,34.8L24.8,34.8C25.2,34.8 25.5,34.5 25.5,34.1C25.5,33.7 25.2,33.4 24.8,33.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,36.6L14.3,36.6C13.9,36.6 13.6,36.9 13.6,37.3C13.6,37.7 13.9,38 14.3,38L24.8,38C25.2,38 25.5,37.7 25.5,37.3C25.5,37 25.2,36.6 24.8,36.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,39.9L15.9,39.9C15.5,39.9 15.2,40.2 15.2,40.6C15.2,41 15.5,41.3 15.9,41.3L23.2,41.3C23.6,41.3 23.9,41 23.9,40.6C23.9,40.2 23.6,39.9 23.2,39.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,43.1L18.2,43.1C17.8,43.1 17.5,43.4 17.5,43.8C17.5,44.2 17.8,44.5 18.2,44.5L20.9,44.5C21.3,44.5 21.6,44.2 21.6,43.8C21.6,43.4 21.3,43.1 20.9,43.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.9,
    cy: 23.4,
    r: 0.7,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15231,0,0,1.15231,-13.9857,21.5416)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.3,9.6L53.3,21.4C53.3,21.7 53.1,21.9 52.8,21.9L50.8,21.9C50.5,21.9 50.3,21.7 50.3,21.4L50.3,14L48,19.6C47.9,19.8 47.7,19.9 47.5,19.9L46.3,19.9C46,19.9 45.9,19.8 45.8,19.6L43.5,14.1L43.5,21.5C43.5,21.8 43.3,22 43,22L41,22C40.7,22 40.5,21.8 40.5,21.5L40.5,9.6C40.5,9.3 40.7,9.1 41,9.1L43.4,9.1C43.7,9.1 43.8,9.2 43.9,9.4L46.9,16.4L49.9,9.4C50,9.2 50.2,9.1 50.4,9.1L52.9,9.1C53.1,9.2 53.3,9.3 53.3,9.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9,17.4C54.9,14.7 57,12.6 59.7,12.6C62.4,12.6 64.5,14.7 64.5,17.4C64.5,20.1 62.4,22.2 59.7,22.2C57,22.2 54.9,20.1 54.9,17.4ZM61.8,17.4C61.8,16.1 60.9,15.3 59.7,15.3C58.5,15.3 57.6,16.2 57.6,17.4C57.6,18.6 58.5,19.5 59.7,19.5C60.9,19.5 61.8,18.7 61.8,17.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9,13.3L73.9,21.5C73.9,21.8 73.7,22 73.4,22L71.6,22C71.3,22 71.1,21.8 71.1,21.5L71.1,21.1C70.7,21.7 69.9,22.2 68.7,22.2C67,22.2 65.8,20.9 65.8,18.6L65.8,13.3C65.8,13 66,12.8 66.3,12.8L68.1,12.8C68.4,12.8 68.6,13 68.6,13.3L68.6,18.4C68.6,19.3 69.1,19.7 69.8,19.7C70.6,19.7 71.1,19.2 71.1,18.2L71.1,13.3C71.1,13 71.3,12.8 71.6,12.8L73.4,12.8C73.7,12.8 73.9,13 73.9,13.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,19.2C83.1,21.3 81.3,22.2 79.3,22.2C77.4,22.2 75.8,21.4 75.5,19.4C75.5,19.1 75.6,18.9 75.9,18.9L77.7,18.9C78,18.9 78.1,19 78.2,19.3C78.3,19.6 78.7,19.8 79.2,19.8C80,19.8 80.3,19.5 80.3,19.2C80.3,17.9 75.5,19.1 75.5,15.6C75.5,13.5 77.3,12.6 79.2,12.6C80.9,12.6 82.6,13.4 82.8,15.4C82.8,15.7 82.7,15.9 82.4,15.9L80.6,15.9C80.3,15.9 80.2,15.8 80.1,15.5C80,15.2 79.7,15 79.2,15C78.5,15 78.2,15.3 78.2,15.6C78.3,16.9 83.1,15.6 83.1,19.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6,17.4C93.6,17.6 93.6,17.9 93.6,18.1C93.6,18.4 93.4,18.5 93.1,18.5L90.9,18.5L87,18.5C87.3,19.6 88.2,20 89.1,20C89.6,20 90.1,19.8 90.4,19.5C90.6,19.4 90.7,19.3 91,19.3L92.7,19.3C93,19.3 93.2,19.5 93.1,19.8C92.4,21.4 90.9,22.2 89,22.2C86,22.2 84,20.1 84,17.4C84,14.7 86,12.6 88.9,12.6C91.6,12.6 93.6,14.6 93.6,17.4ZM90.8,16.4C90.5,15.4 89.7,15 88.9,15C87.9,15 87.2,15.5 86.9,16.4L90.8,16.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,19.6L102.5,21.5C102.5,21.8 102.3,22 102,22L96.6,22L95.6,22C95.3,22 95.1,21.8 95.1,21.5L95.1,9.6C95.1,9.3 95.3,9.1 95.6,9.1L97.6,9.1C97.9,9.1 98.1,9.3 98.1,9.6L98.1,19.1L102,19.1C102.3,19.1 102.5,19.3 102.5,19.6Z",
    style: {
      fill: "rgb(41,171,226)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,11.3L103.6,9.6C103.6,9.3 103.8,9.1 104.1,9.1L105.9,9.1C106.2,9.1 106.4,9.3 106.4,9.6L106.4,11.2C106.4,11.5 106.2,11.7 105.9,11.7L104.1,11.7C103.8,11.7 103.6,11.6 103.6,11.3ZM103.6,21.5L103.6,13.3C103.6,13 103.8,12.8 104.1,12.8L105.9,12.8C106.2,12.8 106.4,13 106.4,13.3L106.4,21.5C106.4,21.8 106.2,22 105.9,22L104.1,22C103.8,21.9 103.6,21.8 103.6,21.5Z",
    style: {
      fill: "rgb(41,171,226)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.3,12.8C117.6,12.8 117.8,13 117.8,13.3L117.8,21.5C117.8,24.6 115.3,25.9 113.1,25.9C110.9,25.9 108.8,24.8 108.5,22.7C108.5,22.4 108.7,22.2 109,22.2L110.8,22.2C111.1,22.2 111.2,22.3 111.3,22.6C111.5,23.1 112.1,23.5 113.1,23.5C114.3,23.5 115.1,22.8 115.1,21.6L115.1,20.8C114.5,21.5 113.6,22 112.3,22C109.9,22 107.9,19.9 107.9,17.4C107.9,14.9 109.9,12.8 112.3,12.8C113.6,12.8 114.5,13.2 115.1,14L115.1,13.5C115.1,13.2 115.3,13 115.6,13L117.3,12.8ZM115.1,17.2C115.1,15.9 114.2,15.1 112.9,15.1C111.6,15.1 110.7,16 110.7,17.2C110.7,18.5 111.6,19.3 112.9,19.3C114.2,19.3 115.1,18.4 115.1,17.2Z",
    style: {
      fill: "rgb(41,171,226)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,16.2L127.7,21.5C127.7,21.8 127.5,22 127.2,22L125.4,22C125.1,22 124.9,21.8 124.9,21.5L124.9,16.4C124.9,15.5 124.4,15.1 123.7,15.1C122.9,15.1 122.4,15.6 122.4,16.6L122.4,21.5C122.4,21.8 122.2,22 121.9,22L120.1,22C119.8,22 119.6,21.8 119.6,21.5L119.6,9.6C119.6,9.3 119.8,9.1 120.1,9.1L121.9,9.1C122.2,9.1 122.4,9.3 122.4,9.6L122.4,13.6C122.8,13 123.6,12.5 124.8,12.5C126.5,12.6 127.7,13.9 127.7,16.2Z",
    style: {
      fill: "rgb(41,171,226)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4,13.3L134.4,15C134.4,15.3 134.2,15.5 133.9,15.5L132.9,15.5L132.9,21.5C132.9,21.8 132.7,22 132.4,22L130.6,22C130.3,22 130.1,21.8 130.1,21.5L130.1,15.5L129.1,15.5C128.8,15.5 128.6,15.3 128.6,15L128.6,13.3C128.6,13 128.8,12.8 129.1,12.8L130.1,12.8L130.1,10.3C130.1,10 130.3,9.8 130.6,9.8L132.4,9.8C132.7,9.8 132.9,10 132.9,10.3L132.9,12.8L133.9,12.8C134.3,12.8 134.4,13 134.4,13.3Z",
    style: {
      fill: "rgb(41,171,226)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e79389ca1ac609568f0acafa4383293d.svg";
export { ForwardRef as ReactComponent };